import React, { useState } from 'react'
import { useSelector } from "react-redux";
import UploadIndex from './UploadIndex';
import ImageViewer from './ImageViewer';
import { useNavigate } from 'react-router-dom'

import { Container, Button } from '@mui/material';

function ImageManager() {

  const auth = useSelector((state) => state.auth);
  let navigate = useNavigate();

  const [upload, setUpload] = useState(false);

  return (
    <>

      {
        ['Admin', 'Almacen', 'Secretaria', 'Ayudante'].includes(auth.user.rol) ?
          <Container maxWidth='xxl'>
            <Button size='large' variant='outlined' onClick={() => navigate('/dashboard')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
            <Button variant="contained" className='m-3' size='large' onClick={() => setUpload(!upload)}>
              {upload ? 'Cerrar' : 'Subir una nueva imagen'}
            </Button>
          </Container> : <></>
      }
      {upload ? (
        <Container maxWidth={'xxl'} style={{ margin: '48px 0px' }}>
          <UploadIndex />
        </Container>) : <></>
      }

      <Container maxWidth={'xxl'}>
        <ImageViewer />
      </Container>
    </>
  )
}

export default ImageManager